import "./SyncPieChart.css";
import React, { Fragment } from "react";
import {
  AccumulationChartComponent,
  AccumulationSeriesCollectionDirective,
  AccumulationSeriesDirective,
  Inject,
  AccumulationLegend,
  AccumulationTooltip,
} from "@syncfusion/ej2-react-charts";
// import { accData } from "datasource.ts";
const SyncPieChart = ({
  id,
  TotalOpenDeals,
  TotalWonDeals,
  TotalLostDeals,
  TotalAutoLostDeals,
}) => {
  const legendSettings = {
    shapeHeight: 20,
    shapeWidth: 20,
  };
  const dataLabel = { visible: true, angle: 90, enableRotation: true };
  const tooltip = { enable: true };

  //   export let data1: any[] = [
  //     { x: "Egg", y: 106 },
  //     { x: "Fish", y: 103 },
  //     { x: "Misc", y: 198 },
  //     { x: "Tea", y: 189 },
  //     { x: "Fruits", y: 250 },
  //   ];
  let chartData = [
    {
      x: "Open Deals",
      y: TotalOpenDeals,
      fill: "rgb(78, 55, 166)",
    },
    { x: "Won Deals", y: TotalWonDeals, fill: "rgb(36, 135, 17)" },
    { x: "Lost Deals", y: TotalLostDeals, fill: "rgb(166, 8, 30)" },
    { x: "Archived", y: TotalAutoLostDeals, fill: "rgb(200, 105, 37)" },
  ];

  return (
    <Fragment>
      {/* {TotalOpenDeals !== 0 || TotalWonDeals !== 0 || TotalLostDeals !== 0 || ( */}
      <AccumulationChartComponent
        className="dashboard-deals-pie-chart"
        id={id}
        legendSettings={legendSettings}
        tooltip={tooltip}
      >
        <Inject services={[AccumulationLegend, AccumulationTooltip]} />
        <AccumulationSeriesCollectionDirective>
          <AccumulationSeriesDirective
            dataSource={chartData}
            pointColorMapping="fill"
            xName="x"
            yName="y"
            legendShape="Circle"
            pointClick={(props) => {}}
            chartMouseClick={(props) => {}}
          ></AccumulationSeriesDirective>
        </AccumulationSeriesCollectionDirective>
      </AccumulationChartComponent>
      {/* )} */}
    </Fragment>
  );
};

export default SyncPieChart;
